<template>
    <!-- body -->
    <tq-loader-container :p_show-loader_b="!server_gameStatus_c || !server_questBody_c || !server_currentUserData_c" :p_tq-loader_b="true" class="TQ_maxWidth_700px TQ_center">
    

        <div v-if="server_gameStatus_c && server_questBody_c && server_currentUserData_c" >

            <!-- 1) quest event info -->
            <div class="TQ_margin_bottom_8px">

                <tq-img-fill-blur :p_height_s="co_mainImageHeight_s"
                                  :pp_img-url_s="store_questEvent_c.qev_cm_getImageFile_c(store_system_langCode_ve.val).fi_url_s"/>

                <tq-event-status-bar
                        v-if="store_ongoing_currentTeamId_vUid.val && !co_showSelectPlayerPath_b"
                        :p_uid_s="$options.name"

                        :p_quest-event_c="store_questEvent_c"
                        :p_game-status_c="server_gameStatus_c"
                        :p_quest-body_c="server_questBody_c"
                        :p_current-team-id_uid="store_ongoing_currentTeamId_vUid.val"

                        :p_system_lang-code_e="store_system_langCode_ve.val"
                />

                <div class="TQ_padding_8px TQ_bg_white">
                    <div class="TQ_text_bold TQ_text_24px"> {{ store_questEvent_c.cm_qev_getName_fs(store_system_langCode_ve.val)}}</div>
                    <div class="TQ_direction_ltr TQ_padding_2px"> {{ formatDateFull_l(store_questEvent_c.qev_startingDate_t)}}</div>
                </div>

            </div>

            <!-- 2) ticket enter code -->
            <div class="TQ_bg_white TQ_margin_bottom_8px TQ_padding_12px" v-if="store_ongoing_ticketShortKey_vs.val">

                <img :src="ass_img_info2_b" class="TQ_width_20px TQ_verticalAlignMiddle"/>

                <div class="TQ_padding_8px TQ_verticalAlignMiddle TQ_inline"></div>

                <div class="TQ_inline TQ_verticalAlignMiddle TQ_clickable" @click="m_copyTicketShortKey_f">
                    <div class="TQ_inline TQ_verticalAlignMiddle">
                        <div class="TQ_inline">{{ass_strings.twoWords_entryCode[store_system_langCode_ve.val]}}:</div>
                        <div class="TQ_padding_2px TQ_inline"></div>
                        <div class="TQ_inline TQ_bg_gold TQ_padding_4px TQ_borderRadius TQ_text_bold">{{store_ongoing_ticketShortKey_vs.val}}</div>
                    </div>

                    <div class="TQ_padding_8px TQ_verticalAlignMiddle TQ_inline"></div>
                    <img :src="ass_img_copyLink_b" class="TQ_width_16px TQ_verticalAlignMiddle" />
                </div>

            </div>

            <!-- 2) join quest/ create team -->
            <div v-if="store_ongoing_currentTeamId_vUid.val == null" class="TQ_padding_8px TQ_bg_white">

                <!-- single player-->
                <div v-if="co_singlePlayer_b">
                    <tq-loader-button :show-loader="createTeamLoader_b"
                                      :text="ass_strings.twoWords_joinQuest[store_system_langCode_ve.val]"
                                      @click.native="m_createSinglePlayerTeam_f"
                                      btn-class="TQ_bg_purple TQ_borderRadius TQ_text_24px  TQ_inline TQ_margin_top_8px"
                    />
                </div>

                <!-- teams -->
                <tq-tabs :p_tabs_ao="co_chooseTeamTabs_ao"
                         v-else
                         p_att_s="title"
                         :p_selected-tab-index_vn="selectedTabIndex_p"
                         :p_display_lang-code_e="store_system_langCode_ve.val"
                         class="TQ_bg_gray4">

                    <!-- 0) Join Team -->
                    <div v-if="co_chooseTeamTabs_ao[selectedTabIndex_p.val].id === 0" class="TQ_bg_white TQ_margin_0_8px TQ_margin_bottom_8px TQ_padding_16px ">

                        <div v-if="objIsEmpty_l(server_gameStatus_c.gs_teams_byTeamId)" class="TQ_text_24px TQ_padding_8px">
                            {{ass_strings.twoWords_noTeam[store_system_langCode_ve.val]}}
                        </div>

                        <div v-else>
                            <!-- team name -->
                            <tq-dropdown class="lc_dropdown TQ_margin_bottom_8px"
                                         max-height="min(calc(100vh - 24px), 500px)"
                                         max-width="300px"
                                         :ps_only-mobile-mode_b="true"
                                         :p_show-search-bar_b="obj_size_fn(server_gameStatus_c.gs_teams_byTeamId) > gv_numbers.dropdown_showSearchBar_minRows"
                                         :p_system-lang-code_e="store_system_langCode_ve.val"
                                         :pe_update-search_f="(searchVal) => {chooseTeam_searchVal_s=searchVal}">

                                <div slot="select" class="select">
                                    <span  v-if="selectedJoinTeamId"> {{server_gameStatus_c.gs_teams_byTeamId[selectedJoinTeamId].gst_name_s}} </span>
                                    <span  v-else> {{ass_strings.twoWords_TeamName[store_system_langCode_ve.val]}} </span>
                                </div>

                                <div slot="options"
                                     @click="selectedJoinTeamId = gs_team_c.gst_teamId_uid"
                                     class="option TQ_clickable TQ_bg_hover_goldLite"
                                     :class="{'TQ_optionSelected': selectedJoinTeamId === gs_team_c.gst_teamId_uid}"
                                     :key="index_n"
                                     v-for="(gs_team_c, index_n) in co_chooseTeam_as">
                                    {{gs_team_c.gst_name_s}}
                                </div>
                            </tq-dropdown>

                            <!-- team password-->
                            <input class="TQ_input TQ_fullScreen TQ_padding_8px TQ_text_20px TQ_direction_ltr"
                                   type="password"
                                   :placeholder="ass_strings.twoWords_teamPassword[store_system_langCode_ve.val]"
                                   v-model="joinTeam_password_s"/>

                            <!-- btn -->
                            <div class="TQ_box_shadow TQ_bg_green TQ_borderRadius TQ_text_24px TQ_padding_8px TQ_inline TQ_margin_top_8px"
                                 @click="m_joinTeam_f()">
                                {{ass_strings.twoWords_joinTeam[store_system_langCode_ve.val]}}
                            </div>
                        </div>

                    </div>

                    <!-- 1) new Team -->
                    <div v-if="co_chooseTeamTabs_ao[selectedTabIndex_p.val].id === 1" class="TQ_bg_white TQ_margin_0_8px TQ_margin_bottom_8px TQ_padding_16px">

                        <!-- team name-->
                        <input class="TQ_input TQ_fullScreen TQ_padding_8px TQ_text_20px TQ_margin_bottom_8px"
                               :placeholder="ass_strings.twoWords_TeamName[store_system_langCode_ve.val]"
                               v-model="newTeam_name_s"/>

                        <!-- team password-->
                        <input class="TQ_input TQ_fullScreen TQ_padding_8px TQ_text_20px TQ_margin_bottom_8px"
                               :placeholder="ass_strings.twoWords_teamPassword[store_system_langCode_ve.val]"
                               v-model="newTeam_password_s"/>

                        <!-- team route -->
                        <tq-dropdown v-if="co_showSelectTeamPath_b"
                                     class="TQ_margin_bottom_8px"
                                     max-height="calc(100vh - 24px)"
                                     max-width="300px"
                                     :ps_only-mobile-mode_b="true"
                                     :p_show-search-bar_b="obj_size_fn(server_gameStatus_c.gs_teams_byTeamId) > gv_numbers.dropdown_showSearchBar_minRows"
                                     :p_system-lang-code_e="store_system_langCode_ve.val"
                                     :pe_update-search_f="(searchVal) => {chooseTeam_searchVal_s=searchVal}">

                            <div slot="select" class="select">
                                <span  v-if="selectedRouteIndex_n!= null"> {{server_questBody_c.qb_missionsArrangements_ac[selectedRouteIndex_n].qbma_name_s}} </span>
                                <span  v-else> {{ass_strings.twoWords_chooseRoute[store_system_langCode_ve.val]}} </span>
                            </div>

                            <div slot="options"
                                 class="TQ_clickable  TQ_border_bottom"
                                 v-for="(qb_missionsOrder_c, index_n) in server_questBody_c.qb_missionsArrangements_ac">
                                <div v-if="co_teamsSelectedRouteIndex_ac.includes(index_n)" class="TQ_grid_col_auto1fr" @click.stop="m_clickChoosedGroup_f">
                                    <div class="TQ_padding_8px TQ_bg_red"> <img :src="ass_img_checked_w" class="TQ_width_20px"/> </div>
                                    <div class="TQ_padding_8px TQ_bg_gray3"> {{qb_missionsOrder_c.qbma_name_s}} </div>
                                </div>
                                <div v-else class="TQ_padding_8px TQ_bg_hover_goldLite" @click="selectedRouteIndex_n = index_n">
                                    {{qb_missionsOrder_c.qbma_name_s}}
                                </div>
                            </div>

                        </tq-dropdown>

                        <!-- team color-->
                        <tq-pick-color :p_system-lang-code_e="store_system_langCode_ve.val"
                                       :pe_change-color_s="(newColor_s) => {this.newTeam_color_s = newColor_s}"
                                       class="TQ_margin_bottom_8px"
                                       :p_init-color_s="newTeam_color_s">
                            <div class="TQ_padding_12px TQ_text_20px TQ_border_darkGray" :style="{'background': newTeam_color_s}">
                                {{ass_strings.twoWords_teamColor[store_system_langCode_ve.val]}}
                            </div>
                        </tq-pick-color>

                        <!-- btn create team-->
                        <tq-loader-button :show-loader="createTeamLoader_b"
                                          :text="ass_strings.twoWords_createTeam[store_system_langCode_ve.val]"
                                          @click.native="m_createTeam_f"
                                          btn-class="TQ_bg_green TQ_borderRadius TQ_text_24px  TQ_inline TQ_margin_top_8px"
                        />

                    </div>


                </tq-tabs >
            </div>

            <!-- 3) choose player route -->
            <div v-else-if="co_showSelectPlayerPath_b" class="TQ_padding_8px TQ_bg_white">

                <tq-dropdown class="TQ_margin_bottom_8px TQ_maxWidth_300px"
                             max-height="calc(100vh - 24px)"
                             max-width="300px"
                             :ps_only-mobile-mode_b="true"
                             :p_show-search-bar_b="obj_size_fn(server_gameStatus_c.gs_teams_byTeamId) > gv_numbers.dropdown_showSearchBar_minRows"
                             :p_system-lang-code_e="store_system_langCode_ve.val"
                             :pe_update-search_f="(searchVal) => {chooseTeam_searchVal_s=searchVal}">

                    <div slot="select" class="select">
                        <tq-beacon :p_show-beacon_b="selectedRouteIndex_n == null">
                            <span  v-if="selectedRouteIndex_n!= null"> {{server_questBody_c.qb_missionsArrangements_ac[selectedRouteIndex_n].qbma_name_s}} </span>
                            <span  v-else> {{ass_strings.twoWords_chooseRoute[store_system_langCode_ve.val]}} </span>
                        </tq-beacon>
                    </div>

                    <div slot="options"
                         class="TQ_clickable TQ_border_bottom"
                         v-for="(qb_missionsOrder_c, index_n) in server_questBody_c.qb_missionsArrangements_ac">
                        <!--<div v-if="co_teamsSelectedRouteIndex_ac.includes(index_n)" class="TQ_grid_col_auto1fr" @click.stop="m_clickChoosedGroup_f">-->
                            <!--<div class="TQ_padding_8px TQ_bg_red"> <img :src="ass_img_checked_w" class="TQ_width_20px"/> </div>-->
                            <!--<div class="TQ_padding_8px TQ_bg_gray3"> {{qb_missionsOrder_c.qbma_name_s}} </div>-->
                        <!--</div>-->
                        <div class="TQ_padding_8px TQ_bg_hover_goldLite" @click="selectedRouteIndex_n = index_n">
                            {{qb_missionsOrder_c.qbma_name_s}}
                        </div>
                    </div>

                </tq-dropdown>


                <div v-if="this.selectedRouteIndex_n!= null">

                    <tq-btn-approve
                            class="TQ_inline TQ_clickable"
                            :system-lang-code="store_system_langCode_ve.val"
                            :popup-text="ass_strings.question_choosePath"
                            :approve-cb="m_playerChooseRoute_f">
                        <tq-beacon :p_show-beacon_b="true">
                            <div class="TQ_padding_8px TQ_bg_purple TQ_inline TQ_borderRadius TQ_box_shadow TQ_text_20px "  >
                                {{ass_strings.oneWord_approve[store_system_langCode_ve.val]}}
                            </div>
                        </tq-beacon>
                    </tq-btn-approve>

                </div>


            </div>

            <!-- 3) start quest -->
            <div v-else-if="co_showStartQuestBtn_b" class="TQ_bg_white TQ_margin_top_8px TQ_padding_8px">
                <div class="TQ_animation_beacon TQ_borderRadius">
                    <div  class="TQ_padding_8px TQ_text_24px TQ_bg_purple TQ_box_shadow TQ_borderRadius TQ_clickable"
                          @click="showPopup_startQuest_vb.val=true">
                        {{ass_strings.twoWords_startQuest[store_system_langCode_ve.val]}}
                    </div>
                </div>
            </div>

            <!-- 3) review quest -->
            <div class="TQ_bg_white TQ_margin_top_8px TQ_padding_8px"
                 v-if="co_showWriteReview_b">
                <div class="TQ_animation_beacon TQ_borderRadius">
                    <div  class="TQ_padding_8px TQ_text_24px TQ_bg_purple TQ_box_shadow TQ_borderRadius TQ_clickable"
                          @click="showPopup_review_vb.val=true">
                        {{ass_strings.twoWords_writeReview[store_system_langCode_ve.val]}}
                    </div>
                </div>
            </div>

            <!-- 4) game status -->
            <div class="lc_gameStatus">



                <!-- single player-->
                <div v-if="co_singlePlayer_b">
                    <div class="section" v-if="obj_size_fn(server_gameStatus_c.gs_teams_byTeamId) > 0 && server_questBody_c">


                        <div class="TQ_text_28px">
                            {{ass_strings.oneWord_players[store_system_langCode_ve.val] }}
                        </div>

                        <div class="TQ_bg_gray4 TQ_padding_6px TQ_borderRadius TQ_borderBox">
                                <tq-table
                                        class="TQ_bg_white TQ_selectable TQ_padding_4px TQ_borderRadius"
                                        :rows="co_getOrderTeamIds_auid"
                                        :system-lang-code="store_system_langCode_ve.val"
                                        p_td-classes_s="TQ_padding_4px"
                                        :p_selected-row-index_n="co_getOrderTeamIds_auid.map((gs_team_c) => gs_team_c.gst_teamId_uid).indexOf(store_ongoing_currentTeamId_vUid.val)"
                                        :columns="[
                                // 1) image
                                {label:ass_strings.oneWord_image[store_system_langCode_ve.val], imgClass_f: () => 'TQ_width_24px TQ_borderRadius' ,
                                avatar_f:(gs_team_c) =>
                                    playersData_byUserId_c[gs_team_c.gst_teamId_uid] && playersData_byUserId_c[gs_team_c.gst_teamId_uid].ud_avatar_c
                                },
                                // 2) name
                                {label : ass_strings.oneWord_name[store_system_langCode_ve.val],html_f:(gs_team_c) =>
                                    gs_team_c.gst_name_s
                                },
                                // 3) route
                                co_showSelectTeamPath_b &&{label : ass_strings.oneWord_route[store_system_langCode_ve.val], html_f:(gs_team_c) =>
                                    server_questBody_c.qb_missionsArrangements_ac[server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid].gst_missionsArrangementIndex_n].qbma_name_s
                                },
                                // 5) points
                                co_supportPoints_b && !co_hideTeamStatus_b &&  {label : ass_strings.oneWord_points[store_system_langCode_ve.val], html_f:(gs_team_c) =>
                                    `<div class='TQ_direction_ltr'>${server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid].gst_m_totalPoints_n()}</div>`
                                },
                                // 6) netTime
                                co_showNetTime_b && !co_hideTeamStatus_b && {label : ass_strings.twoWords_totalTime2[store_system_langCode_ve.val],            html_f:(gs_team_c) =>
                                    `<div class='TQ_direction_ltr'>${format_duration_hhmmss(server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid].gst_m_netTimeMillScn_fn())}</div>`
                                },
                                // 7) totalTime
                                !co_showNetTime_b && !co_hideTeamStatus_b && !co_finishQuestNone_b && {label : ass_strings.twoWords_totalTime2[store_system_langCode_ve.val],         html_f:(gs_team_c) =>
                                    `<div class='TQ_direction_ltr'>${helper_getFinishDuration_fs({questEvent_c:store_questEvent_c, gameStatus_c: server_gameStatus_c, teamId_uid: gs_team_c.gst_teamId_uid,clockStartClock_e: store_questEvent_c.qev_startClockType_e})}</div>`
                                },
                            ].filter(col => col !== false)"
                                    />

                            </div>

                    </div>
                </div>

                <!--teams -->
                <div v-else>

                    <!-- Players -->
                    <div class="section" v-if="server_gameStatus_c.gs_teams_byTeamId[store_ongoing_currentTeamId_vUid.val] != null">
                        <div class="TQ_text_28px">
                            {{ass_strings.twoWords_teamPlayers[store_system_langCode_ve.val]}}
                        </div>

                        <div class="TQ_bg_gray4 TQ_padding_6px TQ_borderRadius">
                            <tq-table
                                    class="TQ_bg_white TQ_selectable TQ_padding_4px TQ_borderRadius TQ_borderBox"
                                    :rows="obj_toArray_fo(server_gameStatus_c.gs_teams_byTeamId[store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c)"
                                    :system-lang-code="store_system_langCode_ve.val"
                                    p_td-classes_s="TQ_padding_4px"
                                    :p_selected-row-index_n="obj_toKeysArray_fo(server_gameStatus_c.gs_teams_byTeamId[store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c).indexOf(server_currentUserData_c.ud_userId_uid)"
                                    :columns="[
                                // 1) color
                                {label:ass_strings.oneWord_image[store_system_langCode_ve.val], imgClass_f: () => 'TQ_width_32px TQ_borderRadius' ,avatar_f:(gst_player_c) =>
                                    playersData_byUserId_c[gst_player_c.gstp_playerId_uid] && playersData_byUserId_c[gst_player_c.gstp_playerId_uid].ud_avatar_c
                                },
                                // 2) name
                                {label : ass_strings.oneWord_name[store_system_langCode_ve.val],html_f:(gst_player_c) =>
                                    playersData_byUserId_c[gst_player_c.gstp_playerId_uid] && playersData_byUserId_c[gst_player_c.gstp_playerId_uid].ud_name_s
                                },
                                // // 3) distance
                                // {label : ass_strings.oneWord_distance[store_system_langCode_ve.val],html_f:(gst_player_c) =>
                                //     playersMoreInfo_ByUserId[gst_player_c.gstp_playerId_uid] != null
                                //     ? `${playersMoreInfo_ByUserId[gst_player_c.gstp_playerId_uid].pmi_walkInMeters_n} ${ass_strings.oneLetter_m[store_system_langCode_ve.val]}`
                                //     : ' - '
                                // },
                                // // 4) battery
                                // {label : ass_strings.oneWord_battery[store_system_langCode_ve.val],html_f:(gst_player_c) =>
                                //     ''
                                // },
                                co_supportSelectPlayerPath_b && {label : ass_strings.oneWord_path[store_system_langCode_ve.val],html_f:(gst_player_c) =>
                                    m_playerPathName_s(gst_player_c.gstp_playerId_uid)
                                },

                            ].filter(col => col !== false)"
                            />
                        </div>

                        <table class="TQ_width_100p" v-if="false">
                            <tr>
                                <th>#</th>
                                <th>{{ass_strings.oneWord_image[store_system_langCode_ve.val]}}</th>
                                <th>{{ass_strings.oneWord_name[store_system_langCode_ve.val]}}</th>
                                <th>{{ass_strings.oneWord_distance[store_system_langCode_ve.val]}}</th>
                                <th>{{ass_strings.oneWord_battery[store_system_langCode_ve.val]}}</th>
                                <th v-if="co_supportSelectPlayerPath_b">{{ass_strings.oneWord_path[store_system_langCode_ve.val]}}</th>
                            </tr>

                            <tr v-for="(timestamp, playerId, index_n) in server_gameStatus_c.gs_teams_byTeamId[store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c"
                                :class="{'TQ_bg_gold' : playerId === server_currentUserData_c.ud_userId_uid}"
                                v-if="playersData_byUserId_c[playerId] != null && server_currentUserData_c">
                                <td>{{index_n + 1}}</td>
                                <td >
                                    <tq-avatar :p_ud_avatar_c="playersData_byUserId_c[playerId].ud_avatar_c"
                                               :key="$options.name + playerId"
                                               class="TQ_width_36px TQ_borderRadius"/>
                                </td>
                                <td >{{ playersData_byUserId_c[playerId].ud_name_s }}</td>
                                <td >
                                    <div v-if="playersMoreInfo_ByUserId[playerId]">
                                        {{playersMoreInfo_ByUserId[playerId].pmi_walkInMeters_n}} {{ass_strings.oneLetter_m[store_system_langCode_ve.val]}}
                                    </div>
                                </td>
                                <td class="TQ_padding_4px">

                                    <tq-progress-bar
                                            class="TQ_text_12px TQ_textColor_white "
                                            v-if="playersMoreInfo_ByUserId[playerId] && playersMoreInfo_ByUserId[playerId].pmi_batteryLevel_n >= 0"
                                            :p_progress_n="playersMoreInfo_ByUserId[playerId].pmi_batteryLevel_n / 100"
                                            ps_line-height_s="16px"/>

                                </td>
                                <td v-if="co_supportSelectPlayerPath_b">
                                    {{m_playerPathName_s(playerId)}}
                                </td>

                            </tr>

                        </table>

                    </div>

                    <!-- teams -->
                    <div v-if="obj_size_fn(server_gameStatus_c.gs_teams_byTeamId) > 0 && server_questBody_c" class="section" >
                        <div class="TQ_text_28px"> {{ass_strings.oneWord_teams[store_system_langCode_ve.val]}}</div>

                        <div class="TQ_bg_gray4 TQ_padding_6px TQ_borderRadius TQ_borderBox">
                            <tq-table
                                    class="TQ_bg_white TQ_selectable TQ_padding_4px TQ_borderRadius"
                                    :rows="co_getOrderTeamIds_auid"
                                    :system-lang-code="store_system_langCode_ve.val"
                                    p_td-classes_s="TQ_padding_4px"
                                    :p_selected-row-index_n="co_getOrderTeamIds_auid.map((gs_team_c) => gs_team_c.gst_teamId_uid).indexOf(store_ongoing_currentTeamId_vUid.val)"
                                    :columns="[
                            // 1) color
                            {label:ass_strings.oneWord_color[store_system_langCode_ve.val], html_f:(gs_team_c) =>
                                `<div class='TQ_width_32px TQ_height_24px TQ_center TQ_borderRadius TQ_box_shadow' style='background: ${gs_team_c.gst_color_s}'></div>`
                            },
                            // 2) name
                            {label : ass_strings.oneWord_name[store_system_langCode_ve.val],html_f:(gs_team_c) =>
                                gs_team_c.gst_name_s
                            },
                            // 3) route
                            co_showSelectTeamPath_b &&{label : ass_strings.oneWord_route[store_system_langCode_ve.val],html_f:(gs_team_c) =>
                                server_questBody_c.qb_missionsArrangements_ac[server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid].gst_missionsArrangementIndex_n].qbma_name_s
                            },
                            // 4) NumOfPlayers
                            {label : ass_strings.threeWords_numberOfPlayers[store_system_langCode_ve.val],  html_f:(gs_team_c) =>
                                getObjSize_l(gs_team_c.gst_players_byUserId_c)
                            },
                            // 5) points
                            co_supportPoints_b && !co_hideTeamStatus_b &&  {label : ass_strings.oneWord_points[store_system_langCode_ve.val], html_f:(gs_team_c) =>
                                `<div class='TQ_direction_ltr'>${server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid].gst_m_totalPoints_n()}</div>`
                            },
                            // 6) netTime
                            co_showNetTime_b && !co_hideTeamStatus_b && {label : ass_strings.twoWords_netTime[store_system_langCode_ve.val],            html_f:(gs_team_c) =>
                                `<div class='TQ_direction_ltr'>${format_duration_hhmmss(server_gameStatus_c.gs_teams_byTeamId[gs_team_c.gst_teamId_uid].gst_m_netTimeMillScn_fn())}</div>`
                            },
                            // 7) totalTime
                            !co_hideTeamStatus_b && !co_finishQuestNone_b && {label : ass_strings.twoWords_totalTime2[store_system_langCode_ve.val],         html_f:(gs_team_c) =>
                                `<div class='TQ_direction_ltr'>${helper_getFinishDuration_fs({questEvent_c:store_questEvent_c, gameStatus_c: server_gameStatus_c, teamId_uid: gs_team_c.gst_teamId_uid,clockStartClock_e: store_questEvent_c.qev_startClockType_e})}</div>`
                            },
                        ].filter(col => col !== false)"
                            />

                        </div>


                    </div>
                </div>

            </div>

            <!-- 5) btns -->
            <div class="TQ_bg_white">

                <!-- 4) exist  -->
                <div class="TQ_btn TQ_text_24px TQ_bg_red TQ_margin_8px TQ_borderRadius"
                     @click="m_exitGame_f()">
                    <img :src="ass_img_exit_w" class="TQ_width_32px TQ_verticalAlignMiddle"/>
                    <div class="TQ_inline TQ_verticalAlignMiddle TQ_padding_4px"></div>
                    <div class="TQ_inline TQ_verticalAlignMiddle"> {{ass_strings.twoWords_exitQuest[store_system_langCode_ve.val]}} </div>
                </div>


            </div>

            <!-- 6) popup start quest-->
            <tq-popup :show="showPopup_startQuest_vb" :show-close-btn="true" max-width="350px" padding="0px">


                <div class="TQ_text_28px TQ_padding_8px TQ_bg_purple_dark TQ_border_bottom TQ_margin_bottom_8px">
                    {{ass_strings.twoWords_startQuest[store_system_langCode_ve.val]}}
                </div>


                <div class="TQ_padding_8px TQ_border_bottom">
                    <div class="TQ_text_capitalize_first_letter">
                        {{ass_strings.sentence_startQuest1[store_system_langCode_ve.val]}}.
                    </div>
                    <div class="TQ_text_capitalize_first_letter">
                        {{ass_strings.sentence_startQuest2[store_system_langCode_ve.val]}}.
                    </div>
                </div>


                <div class="TQ_grid_col_Auto1frAuto TQ_padding_8px ">
                    <div class="TQ_width_60px TQ_bg_gray3 TQ_padding_8px TQ_borderRadius TQ_box_shadow" @click="showPopup_startQuest_vb.val=false">
                        {{ass_strings.oneWord_cancel[store_system_langCode_ve.val]}}
                    </div>
                    <div></div>
                    <div class="TQ_width_60px TQ_bg_green TQ_padding_8px TQ_borderRadius TQ_box_shadow"
                         @click="m_playerStartTeamClock_f">
                        {{ass_strings.oneWord_approve[store_system_langCode_ve.val]}}
                    </div>
                </div>

            </tq-popup>

             <!--popup review-->
            <tq-popup :show="showPopup_review_vb" :show-close-btn="true" max-width="500px" padding="0px" v-if="questReview_c">
                <tq-write-review
                        :p_quest-event_c="store_questEvent_c"
                        :p_window-size-type_e="store_system_windowSizeType_ve.val"
                        :p_quest-review_c="questReview_c"
                        :pe_submit-review_f="m_submitReview_f "

                />
            </tq-popup>

        </div>
    </tq-loader-container>
</template>

<script>

    import {
        format_duration_dayshhmmss, format_duration_hhmmss,
    } from "../../../functions/src/shareCode/Share_S_Format";
    import {
        serverAuth_getOtherUserData_f} from "../../scripts/Server/S_ServerAuth";
    import {helper_copyStringToClipboard, helper_getFinishDuration_fs} from "../../scripts/S_Helper";
    import TqTabs from "../../components/basic/TqTabs";
    import {
        serverOngoing_createNewTeam_f,
        serverOngoing_gameStatus_playerJoinTeam_f,
        serverOngoing_gameStatus_vl_set_f,
        serverOngoing_gameStatus_vl_remove_f,
        serverOngoing_gameStatus_team_playerSetStartTime_f,
        serverOngoing_playerMoreInfo_vl_set_f,
        serverOngoing_playerMoreInfo_vl_remove_f,
        serverOngoing_gameStatus_creatorSetStartTime_update_f,
        serverOngoing_teamStatus_vl_set_f,
        serverOngoing_gameStatus_team_player_path_update_f,
        serverOngoing_createNewTeam_withTeamId_f,
    } from "../../scripts/Server/S_ServerOngoing";
    import {notification_notify} from "../../scripts/S_Notification";
    import {
        enum_arrangeMissionsType_s, enum_finishQuest_s, enum_missions_LocksType_s,
        enum_questEventStartClockTypes_s, enum_questMode_s, enum_screenSizesOptions_n,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {route_moveToRoute, route_refreshPage} from "../../router";
    import {
        store_var,
        store_getStateValue_vo,
    } from "../../store";
    import TqLoaderContainer from "../../components/basic/TqLoaderContainer";
    import {ass_strings} from "../../../functions/src/shareCode/Share_Ass_Dictionary";
    import TqDropdown from "../../components/basic/TqDropdown";
    import TqEventStatusBar from "../../components/basic/TqEventStatusBar";
    import {obj_size_fn, obj_forEach_f, obj_map_fo, obj_toArray_fo, obj_toKeysArray_fo} from "../../../functions/src/shareCode/Share_S_Obj";
    import {serverBig_questBody_once_fp} from "../../scripts/Server/S_ServerFirestore";
    import {validator_objEmpty_fb} from "../../../functions/src/shareCode/Share_S_Validator";
    import {format_date_YYYY_MM_DD_hh_mm_fs, format_langCode_fs} from "../../../functions/src/shareCode/Share_S_Format";
    import {gv_numbers} from "../../../functions/src/shareCode/Share_Ass_GlobalVariable";
    import {
        enum_questEventStatus,
        enum_moveToOptions,
    } from "../../../functions/src/shareCode/Share_S_Enum";
    import {
        date_newDate_fd,
        date_getNowDate_resetSeconds_fd,
    } from "../../scripts/S_Date";
    import {
        ass_img_checked_w,
        ass_img_copyLink_b,
        ass_img_exit_w,
        ass_img_info2_b
    } from "../../assets/scripts/Ass_Files";
    import TqProgressBar from "../../components/basic2/TqProgressBar";
    import {
        serverAuth_currentUserData_get_vl_fp,
        serverAuth_currentUserData_remove_vl_f
    } from "../../scripts/Server/S_ServerAuth";
    import TqImage from "../../components/basic/TqImage";
    import TqPickColor from "../../components/basic2/TqPickColor";
    import TqLoaderButton from "../../components/basic2/TqLoaderButton";
    import TqPopup from "../../components/basic/TqPopup";
    import TqBeacon from "../../components/basic2/TqBeacon";
    import TqOnTopContainer from "../../components/basic/TqOnTopContainer";
    import TqImgFillBlur from "../../components/basic2/TqImgFillBlur";
    import TqWriteReview from "../../components/complex/TqWriteReview";
    import {server_getUserQuestReview_fp, server_submitQuestTqReview_f} from "../../scripts/Server/S_ServerPre";
    import {FB_QuestReview} from "../../../functions/src/shareCode/Share_S_Classes";
    import TqTable from "../../components/basic2/TqTable";
    import TqBtnApprove from "../../components/basic2/TqBtnApprove";
    import TqAvatar from "@/components/complex/TqAvatar";


    export default {
        name: "V_Ongoing_Status",
        components: {
            TqAvatar,
            TqBtnApprove,
            TqTable,
            TqImgFillBlur,
            TqOnTopContainer,
            TqBeacon,
            TqPopup,
            TqLoaderButton,
            TqPickColor,
            TqImage,
            TqProgressBar,
            TqEventStatusBar,
            TqDropdown,
            TqLoaderContainer,
            TqTabs,
            TqWriteReview},
        data(){
            return{

                // local data
                playersData_byUserId_c      : {},
                playersMoreInfo_ByUserId    : {},
                selectedTabIndex_p          : {val : 0},
                newTeam_name_s              : "",
                newTeam_password_s          : null,
                joinTeam_password_s         : "",
                newTeam_color_s             : null,
                selectedJoinTeamId          : null,
                selectedRouteIndex_n        : null,
                createTeamLoader_b          : false,
                showPopup_startQuest_vb     : {val : false},
                showPopup_review_vb         : {val : false},
                chooseTeam_searchVal_s      : '',

                // store
                store_questEvent_c              : store_getStateValue_vo(store_var.ongoing_questEvent).val,
                store_ongoing_currentTeamId_vUid: store_getStateValue_vo(store_var.ongoing_currentTeamId_uid),
                store_questClockStatus          : store_getStateValue_vo(store_var.ongoing_eventCurrentStatus),
                store_system_langCode_ve        : store_getStateValue_vo(store_var.system_langCode),
                store_ongoing_ticketShortKey_vs : store_getStateValue_vo(store_var.ongoing_ticketShortKey_s),
                store_system_windowSizeType_ve  : store_getStateValue_vo(store_var.system_windowSizeType_e),

                // server
                server_currentUserData_c: undefined,
                server_gameStatus_c     : undefined,
                server_questBody_c      : undefined,
                server_ts_bonusPoints_n : undefined,
                questReview_c    : null,


                // imports
                ass_img_checked_w           : ass_img_checked_w,
                ass_img_exit_w              : ass_img_exit_w,
                ass_strings                 : ass_strings,
                ass_img_info2_b             : ass_img_info2_b,
                ass_img_copyLink_b          : ass_img_copyLink_b,
                enum_questEventStartClockTypes_s : enum_questEventStartClockTypes_s,
                enum_arrangeMissionsType_s : enum_arrangeMissionsType_s,
                obj_size_fn: obj_size_fn,
                obj_toArray_fo: obj_toArray_fo,
                obj_toKeysArray_fo: obj_toKeysArray_fo,
                helper_getFinishDuration_fs: helper_getFinishDuration_fs,
                gv_numbers: gv_numbers,

            }
        },
        computed : {

            co_singlePlayer_b(){
                return this.server_questBody_c.qb_metadata_c && this.server_questBody_c.qb_metadata_c.qbm_quest_questMode_e === enum_questMode_s.individual
            },
            co_teamsSelectedRouteIndex_ac(){

                switch(this.server_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e){

                    // player
                    case enum_arrangeMissionsType_s.player_choose_oneTime:

                        if(this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val] != null){
                            return Object.values(obj_map_fo(this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c,  (gst_player_c) => {return gst_player_c.gstp_pathIndex_n}))
                        }
                        return []

                    // team
                    case enum_arrangeMissionsType_s.team_choose_oneTime:
                        return Object.values(obj_map_fo(this.server_gameStatus_c.gs_teams_byTeamId,  (gs_team_c) => {return gs_team_c.gst_missionsArrangementIndex_n}))

                    default:
                        return []
                }

            },

            co_chooseTeam_as(){
                let ans_ac = []
                obj_forEach_f(this.server_gameStatus_c.gs_teams_byTeamId, gs_team_c => {
                    if(gs_team_c.gst_name_s.toLowerCase().includes(this.chooseTeam_searchVal_s.toLowerCase())){
                        ans_ac.push(gs_team_c)
                    }
                })

                return ans_ac.sort((gs_team_c1,gs_team_c2) => {return gs_team_c1.gst_name_s.localeCompare(gs_team_c2.gst_name_s, {numeric: true, sensitivity: 'base'}) ? 1 : -1})
            },
            co_getOrderTeamIds_auid(){

                let ans_ac =  obj_toArray_fo(this.server_gameStatus_c.gs_teams_byTeamId)

                if(this.co_hideTeamStatus_b){
                    return ans_ac
                }

                ans_ac.sort((gs_team_c1,gs_team_c2) => {

                    // 1) sort by points
                    if (gs_team_c1.gst_m_totalPoints_n() != gs_team_c2.gst_m_totalPoints_n()) {
                        return gs_team_c1.gst_m_totalPoints_n() > gs_team_c2.gst_m_totalPoints_n() ? -1 : 1
                    }

                    // sort by finish time
                    if (gs_team_c1.gst_finishTime_t != null || gs_team_c2.gst_finishTime_t != null) {
                        let finishDuration1_s = helper_getFinishDuration_fs({
                            questEvent_c: this.store_questEvent_c,
                            gameStatus_c: this.server_gameStatus_c,
                            teamId_uid: gs_team_c1.gst_teamId_uid,
                            clockStartClock_e: this.store_questEvent_c.qev_startClockType_e
                        })

                        let finishDuration2_s = helper_getFinishDuration_fs({
                            questEvent_c: this.store_questEvent_c,
                            gameStatus_c: this.server_gameStatus_c,
                            teamId_uid: gs_team_c2.gst_teamId_uid,
                            clockStartClock_e: this.store_questEvent_c.qev_startClockType_e
                        })
                        return finishDuration1_s > finishDuration2_s ? 1 : -1
                    }

                    // current user team id
                    return this.store_ongoing_currentTeamId_vUid.val === gs_team_c1.gst_teamId_uid ? -1 : 1

                })

                return ans_ac
            },

            co_mainImageHeight_s(){
                  switch(this.store_system_windowSizeType_ve.val){
                      case enum_screenSizesOptions_n.laptop:
                          return '400px'
                      case enum_screenSizesOptions_n.tablet_big:
                      case enum_screenSizesOptions_n.tablet_small:
                          return '300px'
                      case enum_screenSizesOptions_n.mobile:
                          return '250px'

                  }
            },
            co_qb_displayLangCode_e(){
                return this.server_questBody_c.cm_qb_getDisplayLangCode_e(this.store_system_langCode_ve.val)
            },
            co_chooseTeamTabs_ao(){

                if(validator_objEmpty_fb(this.server_gameStatus_c.gs_teams_byTeamId)){
                    return [{title: ass_strings.twoWords_createTeam, id : 1}]
                }


                return [{title: ass_strings.twoWords_joinTeam,id : 0}, {title: ass_strings.twoWords_createTeam, id : 1}]
            },

            co_showStartQuestBtn_b(){

                let playerCanStart_teamClock_b = this.store_questEvent_c.qev_startClockType_e === enum_questEventStartClockTypes_s.playerStartClock

                let currentTeamId_uid = this.store_ongoing_currentTeamId_vUid.val
                let playerStartedClock_b = currentTeamId_uid && this.server_gameStatus_c.gs_teams_byTeamId[currentTeamId_uid] && this.server_gameStatus_c.gs_teams_byTeamId[currentTeamId_uid].gst_playerStartTime_t != null

                return playerCanStart_teamClock_b && !playerStartedClock_b
            },
            co_showWriteReview_b(){

                let teamFinishQuest_b =  this.store_ongoing_currentTeamId_vUid.val != null && this.server_gameStatus_c && this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val] && this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_finishTime_t != null
                let timeOver_b = this.store_ongoing_currentTeamId_vUid.val && this.store_questClockStatus.val === enum_questEventStatus.finish

                return this.questReview_c != null && (teamFinishQuest_b || timeOver_b)

            },
            co_showSelectTeamPath_b(){

                return this.server_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e === enum_arrangeMissionsType_s.team_choose_oneTime
            },
            co_showSelectPlayerPath_b(){

                let playerChoosePath_b = this.server_gameStatus_c &&
                    this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val] &&
                    this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c[this.server_currentUserData_c.ud_userId_uid] &&
                    this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c[this.server_currentUserData_c.ud_userId_uid].gstp_pathIndex_n


                return playerChoosePath_b == null && this.co_supportSelectPlayerPath_b
            },
            co_supportSelectPlayerPath_b(){
                return this.server_questBody_c.qb_metadata_c.qbm_quest_missionsArrangements_e === enum_arrangeMissionsType_s.player_choose_oneTime
            },
            co_supportPoints_b(){

                return this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b
            },
            co_hideTeamStatus_b(){
                return this.server_questBody_c.qb_metadata_c.qbm_quest_hideTeamsStatus_b
            },
            co_finishQuestNone_b(){
                return this.server_questBody_c.qb_metadata_c.qbm_quest_finishQuest_e === enum_finishQuest_s.none
            },
            co_showNetTime_b(){
                return this.server_questBody_c.qb_metadata_c.qbm_missions_locksType_e === enum_missions_LocksType_s.start_time
            }
        },
        methods: {
            m_playerPathName_s(playerId_uid){

                if(!this.co_supportSelectPlayerPath_b || !this.server_gameStatus_c || !this.store_ongoing_currentTeamId_vUid.val || !playerId_uid){
                    return "-"
                }

                let pathIndex_n = this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c[playerId_uid].gstp_pathIndex_n

                if(pathIndex_n == null){
                    return "-"
                }

                return this.server_questBody_c.qb_missionsArrangements_ac[pathIndex_n].qbma_name_s
            },
            m_playerChooseRoute_f(){

                let gst_player_c = this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val].gst_players_byUserId_c[this.server_currentUserData_c.ud_userId_uid]
                gst_player_c.gstp_pathIndex_n = this.selectedRouteIndex_n

                serverOngoing_gameStatus_team_player_path_update_f(this.store_questEvent_c, this.store_ongoing_currentTeamId_vUid.val, this.server_currentUserData_c.ud_userId_uid, gst_player_c)
            },
            m_setTeamPlayersData_f(){

                if(this.server_gameStatus_c == null || validator_objEmpty_fb(this.server_gameStatus_c.gs_teams_byTeamId)){
                    return
                }

                let team_c = this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val];

                if(team_c == null){
                    return
                }

                for(let playerId_uid in team_c.gst_players_byUserId_c) {


                    if(this.playersData_byUserId_c[playerId_uid] === undefined){

                        // this.playersData_byUserId_c[playerId] = null
                        this.$set(this.playersData_byUserId_c, playerId_uid, null)

                        serverAuth_getOtherUserData_f(playerId_uid, userData_c =>{
                            this.$set(this.playersData_byUserId_c, playerId_uid, userData_c)
                        })
                    }


                    if(this.playersMoreInfo_ByUserId[playerId_uid] === undefined){

                        this.$set(this.playersMoreInfo_ByUserId, playerId_uid, null)


                        // this.$set(this.playersMoreInfo_ByUserId, playerId_uid, new FB_TeamPlayerInfo({
                        //     pmi_batteryLevel_n : 50 * Math.random() +50,
                        //     pmi_walkInMeters_n : parseInt(5000 * Math.random())
                        // }))


                        serverOngoing_playerMoreInfo_vl_set_f(
                            this.$options.name,
                            this.store_questEvent_c,
                            playerId_uid,
                            (playerMoreInfo =>{
                                this.$set(this.playersMoreInfo_ByUserId, playerId_uid, playerMoreInfo)
                            }))
                    }


                }
            },
            m_watch_setRiddleStatusListener_f(){

                if(this.store_ongoing_currentTeamId_vUid.val == null || this.server_ts_bonusPoints_n != null){
                    return
                }

                if(this.server_questBody_c && !this.server_questBody_c.qb_metadata_c.qbm_missions_supportMissionsPoints_b){
                    return
                }

                // listener for bonus points
                this.server_ts_bonusPoints_n = 0
                serverOngoing_teamStatus_vl_set_f({
                    viewName_s: this.$options.name, 
                    questEvent_c : this.store_questEvent_c, 
                    teamId_uid : this.store_ongoing_currentTeamId_vUid.val,
                    cb_f: (teamStatus_c) => {
                        this.server_ts_bonusPoints_n = teamStatus_c ? teamStatus_c.ts_bonusPoints_n : 0

                    }
                })

            },
            m_playerStartTeamClock_f(){
                const nowTime_t = date_newDate_fd().getTime()
                serverOngoing_gameStatus_team_playerSetStartTime_f(this.store_questEvent_c, this.store_ongoing_currentTeamId_vUid.val, nowTime_t, () => {})
                this.showPopup_startQuest_vb.val=false

            },
            m_clickChoosedGroup_f(){
                notification_notify(ass_strings.sentence_chosenRoute)
            },

            // user events
            m_exitGame_f(){
                route_moveToRoute(enum_moveToOptions.player_play_list)
            },
            m_createTeam_f(){

                if(this.newTeam_name_s === ''){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_pleaseChooseTeamName, null)
                    return
                }
                if(!this.newTeam_password_s){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_pleaseChooseTeamPassword, null)
                    return
                }
                if(this.newTeam_password_s.length < gv_numbers.passwordMinLength){
                    notification_notify(ass_strings.oneWord_error, ass_strings.sentence_password6Chars, null)
                    return
                }
                if(this.co_showSelectTeamPath_b && this.selectedRouteIndex_n == null){
                    notification_notify(ass_strings.threeWords_pleaseChooseRoute)
                    return
                }
                if(this.co_showSelectTeamPath_b && this.selectedRouteIndex_n != null && this.co_teamsSelectedRouteIndex_ac.includes(this.selectedRouteIndex_n)){
                    notification_notify(ass_strings.sentence_chosenRoute)
                    return
                }

                if(!this.newTeam_color_s){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_pleaseChooseTeamColor, null)
                    return
                }
                if(this.store_ongoing_currentTeamId_vUid.val != null){
                    notification_notify(ass_strings.oneWord_error, ass_strings.fourWords_cantCreateMultipleTeams, null)
                    return
                }

                this.createTeamLoader_b = true

                serverOngoing_createNewTeam_f(
                    this.store_questEvent_c,
                    this.server_questBody_c,
                    this.newTeam_name_s,
                    this.newTeam_color_s,
                    this.newTeam_password_s,
                    this.selectedRouteIndex_n,
                    this.server_currentUserData_c.ud_userId_uid,
                    (newTeamId) => {
                        this.createTeamLoader_b = false
                        route_refreshPage()
                        notification_notify(ass_strings.threeWords_newTeamCreated)
                    })
            },
            m_createSinglePlayerTeam_f(){
                this.createTeamLoader_b = true

                serverOngoing_createNewTeam_withTeamId_f(
                    this.store_questEvent_c,
                    this.server_questBody_c,
                    this.server_currentUserData_c.ud_name_s,
                    '#000000',
                    '111111',
                    null,
                    this.server_currentUserData_c.ud_userId_uid,
                    this.server_currentUserData_c.ud_userId_uid,
                    (newTeamId) => {
                        this.createTeamLoader_b = false
                        route_refreshPage()
                        notification_notify(ass_strings.twoWords_joinQuest)
                    }
                )
            },
            m_joinTeam_f(){
                if(!this.selectedJoinTeamId){
                    notification_notify(ass_strings.oneWord_error, ass_strings.threeWords_pleaseSelectTeam, null)
                    return
                }

                if(this.joinTeam_password_s !==
                    this.server_gameStatus_c.gs_teams_byTeamId[this.selectedJoinTeamId].gst_teamPassword_s){
                    notification_notify(ass_strings.oneWord_error, ass_strings.twoWords_wrongCode, null)
                    return
                }

                serverOngoing_gameStatus_playerJoinTeam_f(this.store_questEvent_c, this.selectedJoinTeamId, this.server_currentUserData_c.ud_userId_uid, () => {

                    notification_notify(ass_strings.twoWords_joinedTeam)
                })
            },
            m_userEvent_moveToReview_f(){
                route_moveToRoute(enum_moveToOptions.ongoing_status_review)
            },
            m_copyTicketShortKey_f(){
                helper_copyStringToClipboard(this.store_ongoing_ticketShortKey_vs.val)
                notification_notify(ass_strings.threeWords_entryCodeCopied)
            },
            m_submitReview_f(){

                if(this.questReview_c.qr_overallRating_n ==null){
                    notification_notify(ass_strings.oneWord_warning, ass_strings.fourWords_pleaseFillAllFields)
                    return
                }

                if(this.questReview_c.qr_difficulty_n ==null){
                    notification_notify(ass_strings.oneWord_warning, ass_strings.fourWords_pleaseFillAllFields)
                    return
                }

                notification_notify(ass_strings.oneWord_review, ass_strings.sentence_acceptedReview)

                server_submitQuestTqReview_f(this.questReview_c, () => {})


                this.showPopup_review_vb.val = false
                this.questReview_c = null

            },

            //helpers
            formatDateFull_l: format_date_YYYY_MM_DD_hh_mm_fs,
            objIsEmpty_l : validator_objEmpty_fb,
            getObjSize_l : obj_size_fn,
            formatLagCode_l: format_langCode_fs,
            format_duration_dayshhmmss: format_duration_dayshhmmss,
            format_duration_hhmmss: format_duration_hhmmss,

        },
        watch:{
            "store_ongoing_currentTeamId_vUid.val" : {
                handler(){

                    if(this.store_ongoing_currentTeamId_vUid.val == null){
                        return
                    }

                    this.m_watch_setRiddleStatusListener_f()
                    this.m_setTeamPlayersData_f()
                },
                immediate : true
            },
        },
        mounted(){

            // 1) get currentUserData
            serverAuth_currentUserData_get_vl_fp(this.$options.name, (currentUserData) => {

                if(currentUserData == null){
                    return
                }

                this.server_currentUserData_c = currentUserData;

                server_getUserQuestReview_fp(
                    this.store_questEvent_c.qev_questType_e,
                    this.store_questEvent_c.qev_questId_uid,
                    currentUserData.ud_userId_uid,
                    (questReview_c) => {

                        if(questReview_c == null){
                            this.questReview_c =  new FB_QuestReview({
                                qr_questType_e      : this.store_questEvent_c.qev_questType_e,
                                qr_questId_uid      : this.store_questEvent_c.qev_questId_uid,
                                qr_eventId_uid      : this.store_questEvent_c.qev_eventId_uid,
                                qr_reviewerId_uid   : currentUserData.ud_userId_uid,
                                qr_timestamp_t      : date_getNowDate_resetSeconds_fd().getTime()
                            })
                        }

                    }
                )
            })

            // 2) get game status
            serverOngoing_gameStatus_vl_set_f(
                this.$options.name,
                this.store_questEvent_c.qev_questType_e,
                this.store_questEvent_c.qev_questId_uid,
                this.store_questEvent_c.qev_eventId_uid,
                true,
                (gameStatus_c) => {
                    this.server_gameStatus_c = gameStatus_c
                    this.m_setTeamPlayersData_f()
                })


            // 3) get quest body
            serverBig_questBody_once_fp(this.store_questEvent_c.qev_questType_e, this.store_questEvent_c.qev_questId_uid, false, true,
                (questBody_c) => {
                    this.server_questBody_c = questBody_c
                    this.m_watch_setRiddleStatusListener_f()
                })
        },
        destroyed() {
            serverAuth_currentUserData_remove_vl_f(this.$options.name)
            serverOngoing_gameStatus_vl_remove_f(this.$options.name, this.store_questEvent_c)

            if(this.server_gameStatus_c != null && !validator_objEmpty_fb(this.server_gameStatus_c.gs_teams_byTeamId)){
                let team = this.server_gameStatus_c.gs_teams_byTeamId[this.store_ongoing_currentTeamId_vUid.val];

                if(team != null){
                    for (let playerId_uid in team.gst_players_byUserId_c) {

                        serverOngoing_playerMoreInfo_vl_remove_f(
                            this.$options.name,
                            this.store_questEvent_c,
                            playerId_uid,
                            (playerMoreInfo => {
                                this.$set(this.playersMoreInfo_ByUserId, playerId_uid, playerMoreInfo)
                            }))
                    }
                }
            }

        }
    }
</script>

<style scoped lang="scss">


    /* chooseTeam */
    .lc_dropdown{
        border: 1px solid black;
        width: 100%;
        font-size: 20px;
        background: white;

        .select{
            min-height: 20px;
            padding: 8px;
        }

        .option {
            min-height: 20px;
            padding: 8px;
            border-top: 1px solid black;

            :last-child{
                border-bottom: 1px solid black;
            }

        }
    }

    /* game stauts */
    .lc_gameStatus{
        .section{
            background: white;
            margin: 8px 0px;
            padding: 8px;
        }

        .title{
            font-size: 20px;
            text-decoration: underline;
            font-weight: bold;
        }

        table{
            background: white;
            border-collapse: collapse;
            display: inline-block;

            td, th{
                border: 2px solid black;
                padding: 4px;
            }

            td {
                text-transform: none;
            }

            th{
                background: gainsboro;
            }
        }


    }





</style>